var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTopGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28151 11.4641C2.28151 11.6649 2.44435 11.8278 2.64516 11.8278H13.5543C13.7551 11.8278 13.918 11.6649 13.918 11.4641V10.3732H2.28151V11.4641Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0089 2.37318C14.4066 2.37379 13.9186 2.86183 13.918 3.464C13.9197 3.50831 13.9242 3.5525 13.9313 3.59633L10.7631 5.18043L8.67897 2.20302C9.18959 1.88307 9.34401 1.20985 9.02407 0.699355C8.70424 0.188735 8.0309 0.034194 7.5204 0.35414C7.0099 0.674209 6.85536 1.3473 7.17531 1.85792C7.26283 1.99745 7.38076 2.11549 7.5204 2.20302L5.4363 5.18043L2.26808 3.59633C2.27528 3.5525 2.2798 3.50831 2.28151 3.464C2.28444 2.86159 1.79835 2.37074 1.19581 2.36781C0.593275 2.36488 0.102552 2.85097 0.0996224 3.45338C0.0969369 4.00648 0.508558 4.47401 1.05751 4.54152L2.28151 9.64589H13.918L15.1419 4.54152C15.7385 4.4695 16.1637 3.92738 16.0917 3.33082C16.0255 2.78334 15.5603 2.37184 15.0089 2.37318Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopGames);
export default __webpack_public_path__ + "static/media/icon-top-games.2ac88753e43512cb57443373ee69e0e9.svg";
export { ForwardRef as ReactComponent };